export default __webpack_public_path__ + "static/media/bannerBig6.30c45321.png";